import api, { checkTokenErrorResponse } from '..';

const partnerType = [
    [0, "Física"],
    [1, "Jurídica"],
];

const partnerServiceType = [
    [0, 'Cliente'],
    [1, 'Fornecedor'],
];

export async function getPartners() {
    return api.get("parceiros/")
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function postPartner(parceria, tipo, nome, documento, cep, pais, estado, cidade, bairro, logradouro, numero, inscricaoEstadual, iso2, ddi, telefone) {
    const formdata = new FormData();

    formdata.append("parceria", parceria);
    formdata.append("tipo", tipo);
    formdata.append("nome", nome);
    formdata.append("documento", documento);
    formdata.append("cep", cep);
    formdata.append("pais", pais);
    formdata.append("estado", estado);
    formdata.append("cidade", cidade);
    formdata.append("bairro", bairro);
    formdata.append("logradouro", logradouro);
    formdata.append("numero", numero);
    if(telefone)
        formdata.append("telefone", telefone);
    if(ddi)
        formdata.append("ddi", ddi);
    if(iso2)
        formdata.append("iso2_ddi", iso2);
    if(inscricaoEstadual)
        formdata.append("inscricao_estadual", inscricaoEstadual);

    return api.post(`parceiros/`,formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function getPartner(id) {
    return api.get(`parceiros/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function deletePartner(id) {
    return api.delete(`parceiros/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function patchPartner(id, tipo, nome, documento, cep, pais, estado, cidade, bairro, logradouro, numero, inscricaoEstadual, iso2, ddi, telefone) {
    const formdata = new FormData();

    formdata.append("tipo", tipo);
    formdata.append("nome", nome);
    formdata.append("documento", documento);
    formdata.append("cep", cep);
    formdata.append("pais", pais);
    formdata.append("estado", estado);
    formdata.append("cidade", cidade);
    formdata.append("bairro", bairro);
    formdata.append("logradouro", logradouro);
    formdata.append("numero", numero);
    formdata.append("inscricao_estadual", inscricaoEstadual);
    if(telefone)
        formdata.append("telefone", telefone);
    if(ddi)
        formdata.append("ddi", ddi);
    if(iso2)
        formdata.append("iso2_ddi", iso2);

    return api.patch(`parceiros/${id}/`,formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


const partnerServices = {
    getPartner,
    getPartners,
    postPartner,
    deletePartner,
    patchPartner,
    partnerType,
    partnerServiceType,
}
export default partnerServices;